module.exports = __webpack_public_path__ + "img/tu1.8248764c.jpg";